export default __webpack_public_path__ + "media/fogg-waiting.3986b087.png";